{
    "cl_header": {
      "logout": "Terminar sessão"
    },
    "cl_applauncher": {
      "seemoreapplications": "Ver mais Aplicações",
      "spinner": "A carregar...",
      "noApps": "Não há aplicações disponíveis"
    },
    "cl_alert": {
      "dismiss_all": "Dispensar todos",
      "notfication_title": "Notificações",
      "no_notifications": "Sem notificações"
    },
    "cl_side_nav": {
      "support": "Suporte",
      "legal": "Legal"
    },
    "cl_company_switcher": {
      "search_company": "Nome da empresa",
      "loading": "A carregar"
    },
    "applauncher": {
      "spinner": "A carregar..."
    }
  }